import { render, staticRenderFns } from "./Schulpartnerschaft.vue?vue&type=template&id=2ee33609"
import script from "./Schulpartnerschaft.vue?vue&type=script&lang=js"
export * from "./Schulpartnerschaft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports